import React, { useEffect, useState } from "react";

// Importing bootstrap components
import { Navbar, Nav, Dropdown, Image } from "react-bootstrap";

// Importing react router dom components
import { NavLink, useNavigate } from "react-router-dom";

// Importing redux components
import { useDispatch, useSelector } from "react-redux";
import { useLogoutMutation } from "state/slices/auth/authApiSlice";
import { logout } from "state/slices/auth/authSlice";

// Importing images
import Logo from "assets/images/logo.png";
import profilePic from "assets/images/profile.jpg";

import SearchForm from "./SearchForm";

// Importing profile slice
import { useGetProfileQuery } from "state/slices/profile/profileApiSlice";

// Importing auth slice
import { updateUserInfo } from "state/slices/auth/authSlice";

// Import utilities
import { isAllowedToDoByKey } from "permissions-hub";
import {
  PROFILE_MANAGEMENT,
  SEARCH_MANAGEMENT,
  ACCEPTED_PERMISSIONS,
} from "constants";
import {
  isAuthenticated,
  getAllowedPermissions,
} from "utils/authentication";

import LogOutDialog from 'common/LogOutDialog';

const Header = () => {
  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  const [logOutDialogState, setLogOutDialogState] = useState(false);
  const [isTimeOut, setIsTimeOut] = useState(false);

  // Handle sidebar toggle
  const handleToggle = () => {
    document.body.classList.toggle("toggle-sidebar");
  };

  const { data: myProfileData, isLoading: loadingProfileData } =
    useGetProfileQuery();

  // Check search permission
  const isAllowedToSearch = isAllowedToDoByKey(
    SEARCH_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // Check profile permission
  const isAllowedToProfile = isAllowedToDoByKey(
    PROFILE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo)
  );

  const dispatch = useDispatch();

  const logOutDialogHandler = () => {
    if (!isTimeOut) {
      setIsTimeOut(true);
      setTimeout(() => {
        dispatch(logout());
        setIsTimeOut(false);
      }, 5000);
    }
  };  

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      const { message } = await logoutApiCall().unwrap();
      setLogOutDialogState(!logOutDialogState);

      if ( message === 'Logged out Successfully' ) {
        logOutDialogHandler();
      }

    } catch (err) {
      // Error toast is automatically shown by baseQuery
    }
  };

  // Logout on session expire
  useEffect(() => {
    if (!isAuthenticated(loggedUserInfo)) {
      logoutHandler();
    }
  }, []);

  // TODO: Need to change or fix this code as it helps to get data continously from the server for a user profile
  // Fetch changes
  useEffect(() => {
    if (
      !loadingProfileData &&
      JSON.stringify(myProfileData?.lastModified) !==
        JSON.stringify(loggedUserInfo?.lastModified)
    ) {
      dispatch(
        updateUserInfo({
          field: "replace",
          data: myProfileData,
        })
      );
    }
  }, [myProfileData]);

  return (
    <>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="logo d-flex align-items-center justify-content-between">
          <Navbar.Brand
            as={NavLink}
            to="/"
            className="d-flex align-items-center"
          >
            <img src={Logo} alt="Battersea Web Expert Logo" />
          </Navbar.Brand>
          <i
            className="bi bi-list toggle-sidebar-btn"
            onClick={handleToggle}
          ></i>
        </div>
        {isAllowedToSearch && <SearchForm />}
        <Nav className="header-nav ms-auto">
          <Dropdown as={Nav.Item} className="pe-3">
            <Dropdown.Toggle
              as={Nav.Link}
              className="nav-profile d-flex align-items-center pe-0"
            >
              <Image
                src={
                  loggedUserInfo?.biometricDetails?.profilePicture?.length > 0
                    ? loggedUserInfo?.biometricDetails?.profilePicture
                    : profilePic
                }
                onError={e => {
                  e.target.src = profilePic;
                }}
                alt="Profile"
                className="rounded-circle"
              />
              <span className="d-none d-md-block ps-2">
                {loggedUserInfo?.name}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="profile">
              <Dropdown.Header>
                <h6>{loggedUserInfo?.name}</h6>
                <span>{loggedUserInfo?.designation?.name}</span>
              </Dropdown.Header>
              <Dropdown.Divider />
              {isAllowedToProfile && (
                <>
                  <Dropdown.Item as={Nav.Item}>
                    <NavLink
                      className="d-flex align-items-center p-0 text-dark"
                      to="/profile"
                    >
                      <i className="bi bi-person"></i>
                      <span>Profile</span>
                    </NavLink>
                  </Dropdown.Item>
                  <Dropdown.Divider />
                </>
              )}
              <Dropdown.Item
                as={Nav.Item}
                role="button"
                className="d-flex align-items-center"
                onClick={logoutHandler}
              >
                <i className="bi bi-box-arrow-right"></i>
                <span>Sign Out</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </header>
      <LogOutDialog
        show={logOutDialogState}
        onClose={() => {
          logOutDialogHandler();
          setLogOutDialogState(false);
        }}
      />
    </>
  );
};

export default Header;
